import React from 'react';
import PropTypes from 'prop-types';

import LineTitleGray from '../atoms/titles/LineTitleGray';

const SubscriptionPrice = ({
  className, priceTotal, adultPrice, childrenAPrice, childrenBPrice, childrenCPrice, children2Price, infantPrice, people,
}) => {
  const adult = people ? people.adult || 2 : 2;
  const childrenA = people ? people.childrenA || 0 : 0;
  const childrenB = people ? people.childrenB || 0 : 0;
  const infant = people ? people.infant || 0 : 0;
  const childrenC = people ? people.childrenC || 0 : 0;
  const children2 = people ? people.children2 || 0 : 0;

  return (
    <div className={`subscriptionPriceContainer ${className}`}>
      <LineTitleGray size="lg">
        旅行代金
      </LineTitleGray>
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle">大人</div>
        <div>{`${adultPrice.toLocaleString()}円 × ${adult}名`}</div>
      </div>
      {!!childrenA && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">こども(6〜11歳)</div>
          <div>{`${childrenAPrice.toLocaleString()}円 × ${childrenA}名`}</div>
        </div>
      )}
      {!!childrenB && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">こども(3〜5歳)(寝具あり)</div>
          <div>{`${childrenBPrice.toLocaleString()}円 × ${childrenB}名`}</div>
        </div>
      )}
      {!!childrenC && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">こども(3〜5歳)(寝具なし)</div>
          <div>{`${childrenCPrice.toLocaleString()}円 × ${childrenC}名`}</div>
        </div>
      )}
      {!!children2 && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">こども(2歳)</div>
          <div>{`${children2Price.toLocaleString()}円 × ${children2}名`}</div>
        </div>
      )}
      {!!infant && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">こども(0〜1歳)</div>
          <div>{`${infantPrice.toLocaleString()}円 × ${infant}名`}</div>
        </div>
      )}
      <div className="subscriptionPriceBlock total">
        <div className="subscriptionPriceBlockTitle">合計</div>
        <div className="totalPriceArea">
          <div>税込</div>
          <div className="totalPrice">
            {`${priceTotal.toLocaleString()}円`}
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionPrice.defaultProps = {
  className: '',
  priceTotal: 0,
  adultPrice: 0,
  childrenAPrice: 0,
  childrenBPrice: 0,
  childrenCPrice: 0,
  children2Price: 0,
  infantPrice: 0,
};

SubscriptionPrice.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  priceTotal: PropTypes.number,
  adultPrice: PropTypes.number,
  childrenAPrice: PropTypes.number,
  childrenBPrice: PropTypes.number,
  childrenCPrice: PropTypes.number,
  children2Price: PropTypes.number,
  infantPrice: PropTypes.number,
  people: PropTypes.object,
};

export default SubscriptionPrice;
